import React, { lazy } from 'react';
import { Section } from './ui/Section';
export function PreviewImages() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/uTSVYDKnyxd5RFj9yvCcsi/WhatsApp_Image_2026-05-06_at_20.04.47.webp',
    alt: 'Vista interior: Minuto 1 y 2 - Nivel Real y Objetivo',
    width: 800,
    height: 600
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/ofSfsY2ThmX5MtZp7uqXzh/WhatsApp_Image_2026-05-06_at_20.04.47_(1).webp',
    alt: 'Vista interior: F1 - El Básico en Pareja',
    width: 800,
    height: 600
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/wxZ6v2YCg1pnvDXZRF6Q24/WhatsApp_Image_2026-05-06_at_20.04.47_(2).webp',
    alt: 'Vista interior: Ejercicio de Activación Independiente',
    width: 800,
    height: 600
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/9SiCgQBijfMEHQbpDWib9e/WhatsApp_Image_2026-05-06_at_20.04.47_(3).webp',
    alt: 'Vista interior: Los 5 Puntos de Contacto del Líder',
    width: 800,
    height: 600
  }];
  return <Section data-id="element-231">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-232">
        📸 MIRA EL MATERIAL POR DENTRO
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-233">
        {images.map((image, i) => <div key={i} className="bg-gradient-card border border-brand-borderGlow/20 rounded-xl overflow-hidden shadow-violet-glow hover:shadow-gold-glow transition-all" data-id="element-234">
            <img src={image.url} alt={image.alt} width={image.width} height={image.height} loading="lazy" decoding="async" className="w-full h-auto" data-id="element-235" />
          </div>)}
      </div>

      <p className="text-center text-brand-textMuted font-medium tracking-wide" data-id="element-236">
        Material real · Descarga inmediata · Listo para usar hoy
      </p>
    </Section>;
}